import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStarOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.5 1L9.67312 5.4025L14.5312 6.10844L11.0156 9.535L11.8453 14.3744L7.5 12.0897L3.15469 14.3744L3.98438 9.535L0.46875 6.10844L5.32688 5.4025L7.5 1Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconStarOutline;
